import { combineReducers } from 'redux';
import createSaga from './saga';
import { createReduceObject as createCommentTaskExecFormReduceObject } from '../../../common/reducers/execCommentForm';
import { createReduceObject as createExecConfirmFormReduceObject } from '../../../common/reducers/execConfirmForm';
import { createReduceObject as createDisputeTaskExecFormReduceObject } from '../../../common/reducers/execDisputeForm';
import { createReduceObject as createReportTaskExecFormReduceObject } from '../../../common/reducers/execReportForm';
import { createReduceObject as createRefuseTaskExecFormReduceObject } from '../../../common/reducers/execRefuseForm';
import { createReduceObject as createExecRemakeFormReduceObject } from '../../../common/reducers/execRemakeForm';
import { createReduceObject as createExecAnswerConfirmFormReduceObject } from '../../../common/reducers/execAnswerConfirmForm';
import { createReduceObject as createExecCancelByTaskOwnerFormReduceObject } from '../../../common/reducers/execCancelByTaskOwnerForm';
import { createReduceObject as createExecMaterialsAddReducerObject } from '../../../common/reducers/execAddMaterialsReducer';
import { createReduceObject as createExecMaterialsDeleteReducerObject } from '../../../common/reducers/execDeleteMaterialsReducer';
import { reducerRegistry } from '../../../../../reducerRegistry';

// eslint-disable-next-line import/prefer-default-export
export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createCommentTaskExecFormReduceObject(reducerName),
    ...createExecConfirmFormReduceObject(reducerName),
    ...createDisputeTaskExecFormReduceObject(reducerName),
    ...createReportTaskExecFormReduceObject(reducerName),
    ...createRefuseTaskExecFormReduceObject(reducerName),
    ...createExecRemakeFormReduceObject(reducerName),
    ...createExecCancelByTaskOwnerFormReduceObject(reducerName),
    ...createExecAnswerConfirmFormReduceObject(reducerName),
    ...createExecMaterialsAddReducerObject(reducerName),
    ...createExecMaterialsDeleteReducerObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/combineRegistry.js